import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { Pencil } from "lucide-react";
import { useTranslationApp } from "../../lib/i18next";
import { GALLERY_ASSETS_RENAME_ARIA_LABEL } from "../../i18n/keysTranslations";
import { getAssetDisplayName } from "../../utils/assetGalleryUtils";

const GalleryAssetNameCaption = ({ item, onRenameAsset = () => {} }) => {
  const { t } = useTranslationApp();
  const displayName = getAssetDisplayName({ item });

  if (!displayName) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.85,
        minWidth: 0,
        borderTop: "1px solid",
        borderColor: "grey.200",
        bgcolor: "common.white",
      }}
    >
      <Tooltip title={displayName} arrow placement="top">
        <Typography
          variant="caption"
          sx={{
            flex: 1,
            minWidth: 0,
            fontSize: "11px",
            fontWeight: 600,
            color: "grey.800",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {displayName}
        </Typography>
      </Tooltip>
      <Box
        component="button"
        type="button"
        aria-label={t(GALLERY_ASSETS_RENAME_ARIA_LABEL, { name: displayName })}
        onClick={(event) => {
          event.stopPropagation();
          onRenameAsset(item);
        }}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 22,
          height: 22,
          flexShrink: 0,
          p: 0,
          border: "none",
          borderRadius: "50%",
          bgcolor: "grey.100",
          color: "grey.600",
          cursor: "pointer",
          "&:hover": {
            bgcolor: "grey.200",
            color: "grey.900",
          },
        }}
      >
        <Pencil size={11} />
      </Box>
    </Box>
  );
};

export default GalleryAssetNameCaption;
